const styles = () => ({
  saveActions: {
    alignItems: 'center',
    color: '#b2b8c2',
    display: 'flex',
    justifyContent: 'space-around',
    height: 70,
    marginLeft: 'auto',
    zIndex: 10,
  },

  saveContent: {
    alignItems: 'center',
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'flex-end',
    maxWidth: 1294,
    overflow: 'hidden',
  },

  saveDescription: {
    lineHeight: '28px',
    marginRight: '20px',
  },

  saveButton: {
    backgroundImage: 'linear-gradient(to bottom, #3dcf67, #35b491)',
    boxShadow: '0 2px 6px 0 rgba(187, 221, 203, 0.47), 0 1px 2px 0 #b8ddcf',
    textTransform: 'capitalize',
    fontSize: 15,
  },
});

export default styles;
